module.exports = __webpack_public_path__ + "img/error-submit.53876b4.png";